module.exports = __webpack_public_path__ + "01_baby.bd74de17.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_baby.png
// module id = TrZ5
// module chunks = 0